import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { NavMenu } from './NavMenu';

export class Layout extends Component {
  static displayName = Layout.name;

    render() {
    const showNav = this.props.showNav !== false; // Affiche NavMenu sauf si showNav est explicitement faux

    return (
    <div>
        {showNav && <NavMenu />} {/*<NavMenu />*/}
        <Container >
        {this.props.children}
        </Container>
    </div>
    );
  }
}
